import * as React from "react";
function SvgMale(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M23.8 12c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6v.7c.4 3 2.9 5.3 6 5.3zm-.5-9.5c1.9-.2 3.7 1.1 3.9 3 .2 1.9-1.1 3.7-3 3.9-1.9.2-3.7-1.1-3.9-3-.2-1.9 1.1-3.6 3-3.9zM19 14.2L11.1 25l2.1 1.4 5.7-8.2v13.6h1.3V48h2.5V31.7h2.5V48h2.5V31.7H29V18.1l5.9 8.3 2-1.5-8.1-10.7H19m2.5 2.5h5v12.5h-5V16.7z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMale);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
